<div mat-dialog-title style="margin: 0;">
    <span>
        Category Weights for [{{course.Course}}]
    </span>
</div>

<mat-dialog-content>

    <div style="padding-top:15px; padding-bottom:10px;">
        <tyl-form-field label="Grading Period">
            <mat-select [(ngModel)]="selectedGradingPeriod" (ngModelChange)="periodChanged()">
                <mat-option *ngFor="let period of gradingPeriods" [value]="period">
                    {{period.ShortDescription}}
                </mat-option>
            </mat-select>
        </tyl-form-field>
    </div>

    <table>
        <tr>
            <th style="padding-left:10px;">
                Category
            </th>
            <th>
                Weight
            </th>
        </tr>
        <tr *ngFor="let category of categories; let i = index"
            [ngClass]="{'tableOddRow': !isEven(i +1), 'tableEvenRow': isEven(i + 1)}">
            <td style="padding-left:10px;">
                {{category.Description}}
            </td>
            <td>
                {{category.Weight}}%
            </td>
        </tr>
    </table>

</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button id="categoryWeightCloseButton" image="cancel.png" label="Close" (clickEvent)="closeClick()">
        </tyl-button>
    </div>
</mat-dialog-actions>